// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3v2B4","inner":"Footer_inner__2mNrB","nextIcon":"Footer_nextIcon__3u7ys","innerLeft":"Footer_innerLeft__3wGvV"};